import { ControlStateOptions } from "./ControlStateOptions"
import { determineBackgroundClass } from "./determineBackgroundClass"

/**
 *  Determine the CSS class for the background of a control based
 *  on the passed state options.
 */
export function determineControlBackgroundClass(state: ControlStateOptions) {
  // readonly takes precedence over all other states and doesn't have a background.
  if (state.readOnly) {
    return ""
  }

  if (state.disabled) {
    return determineBackgroundClass("background/disabled")
  }

  return determineBackgroundClass("background/default")
}
